import { alias, deserialize, serializable } from 'serializr';
import { Base } from './base.model';
import { PageObject } from './page-object.model';

export class ElementTag extends Base implements PageObject {
  @serializable
  public name: string;
  @serializable(alias('count'))
  public usedCount: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(ElementTag, input));
  }
}
